export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5126.bcae5760.jpg";